<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5003 18.9587H7.50033C2.97533 18.9587 1.04199 17.0253 1.04199 12.5003V7.50033C1.04199 2.97533 2.97533 1.04199 7.50033 1.04199H11.667C12.0087 1.04199 12.292 1.32533 12.292 1.66699C12.292 2.00866 12.0087 2.29199 11.667 2.29199H7.50033C3.65866 2.29199 2.29199 3.65866 2.29199 7.50033V12.5003C2.29199 16.342 3.65866 17.7087 7.50033 17.7087H12.5003C16.342 17.7087 17.7087 16.342 17.7087 12.5003V8.33366C17.7087 7.99199 17.992 7.70866 18.3337 7.70866C18.6753 7.70866 18.9587 7.99199 18.9587 8.33366V12.5003C18.9587 17.0253 17.0253 18.9587 12.5003 18.9587Z"
      :fill="color"
    />
    <path
      d="M18.3337 8.95841H15.0003C12.1503 8.95841 11.042 7.85007 11.042 5.00007V1.66674C11.042 1.41674 11.192 1.18341 11.4253 1.09174C11.6587 0.991739 11.9253 1.05007 12.1087 1.22507L18.7753 7.89174C18.9503 8.06674 19.0087 8.34174 18.9087 8.57507C18.8087 8.8084 18.5837 8.95841 18.3337 8.95841ZM12.292 3.17507V5.00007C12.292 7.15007 12.8503 7.70841 15.0003 7.70841H16.8253L12.292 3.17507Z"
      :fill="color"
    />
    <path
      d="M10.833 11.458H5.83301C5.49134 11.458 5.20801 11.1747 5.20801 10.833C5.20801 10.4913 5.49134 10.208 5.83301 10.208H10.833C11.1747 10.208 11.458 10.4913 11.458 10.833C11.458 11.1747 11.1747 11.458 10.833 11.458Z"
      :fill="color"
    />
    <path
      d="M9.16634 14.792H5.83301C5.49134 14.792 5.20801 14.5087 5.20801 14.167C5.20801 13.8253 5.49134 13.542 5.83301 13.542H9.16634C9.50801 13.542 9.79134 13.8253 9.79134 14.167C9.79134 14.5087 9.50801 14.792 9.16634 14.792Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      default: "#292626",
      type: String,
    },
  },
};
</script>
